import { useLocale } from "../../../hooks/useLocale";
import { msg } from "../../../locales/translate";
import Pre from "@ui/pre/Pre";
import { VBox } from "@ui/box/Box";
import Panel from "@ui/panel/Panel";
import Signal from "badmfck-signal";
import Spacer from "@ui/spacer/Spacer";
import { Typo } from "@ui/text/Typo";
import { FC, useCallback } from "react";

export const S_WEBHOOK_DETAIL_POPUP = new Signal<IDectaSessionPayloadWebhook | null>("S_WEBHOOK_DETAIL_POPUP");


export const WebhookDetailPopup: FC = () => {
	useLocale();
	const data = S_WEBHOOK_DETAIL_POPUP.use();

	const closePopup = useCallback(() => {
		S_WEBHOOK_DETAIL_POPUP.invoke(null);
	}, []);

	if (!data) return null;

	return (
		<Panel
			sx={{
				width: "700px",
				maxWidth: "1200px",
				
				minWidth: "500px",
				maxHeight: "90vh",
			}}
            growContent
			scrollable
			decorator="absolute"
			label={msg("webhook_a60fad90") + data.id}
			onClose={closePopup}>
			<VBox gap="16px">
				<VBox gap="4px">
					<Typo variant="small" sx={{ color: "#6B7280", fontWeight: 500 }}>
						URL
					</Typo>
					<Typo variant="medium" sx={{ wordBreak: "break-all" }}>
						{data.url}
					</Typo>
				</VBox>

				<Spacer size="4px" />

				<VBox gap="6px">
					<Typo variant="medium" sx={{ fontWeight: 600 }}>{msg("request_59f03d64")}</Typo>
                    {/* //!TODO: replace Pre with current styles; */}
					<Pre data={data.text??data.request} wrap />
				</VBox>

				<VBox gap="6px">
					<Typo variant="medium" sx={{ fontWeight: 600 }}>{msg("response_9061383b")}</Typo>
					<Pre data={data.response} wrap />
				</VBox>
			</VBox>
		</Panel>
	);
};
